import MetaHead from "@/components/seo/MetaHead";
import PhotoGallery from "@/components/display/PhotoGallery";
import HeroSection from "@/components/layout/HeroSection";

const baseURL = process.env.NEXT_PUBLIC_BASE_URL;

export default function GalleryPage() {
	return (
		<div>
			<MetaHead
				title="Explore Our Photo Gallery | Riverview Residences"
				description="Explore our photo gallery to see the vibrant life and luxurious amenities at Riverview Residences. Discover what makes our community unique."
				url={`${baseURL}/gallery`}
				image="https://cdn.rentiq.com/samples/riverview-residences/optimized/balcony.webp"
			/>
			<HeroSection
				backgroundImage="https://cdn.rentiq.com/samples/riverview-residences/optimized/balcony.webp"
				fallbackImage="https://cdn.rentiq.com/samples/riverview-residences/fallback/balcony.jpg"
				title="Photo Gallery"
			/>
			<main className="container mx-auto mt-8">
				<PhotoGallery />
			</main>
		</div>
	);
}
